import { v4 as uuidv4 } from 'uuid';
import featuredData from './data/featured-publishers.json';

function getFeaturedPublishers() {
    this.featuredSection = featuredData.section;
    this.featuredPublishers = featuredData.publishers;
    this.observed.featuredPublishers = uuidv4();
}

export default getFeaturedPublishers;
